import { Platform, type ViewStyle } from 'react-native';

// Tailwind shadow tokens come through as CSS variables NativeWind can't resolve
// to RN's native shadow on iOS — apply explicit shadow props so the coach cards
// lift on every platform. Mirrors the vida-design-system demo.
export const NATIVE_CARD_SHADOW: ViewStyle | undefined = Platform.select({
  ios: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
  },
  android: { elevation: 4 },
  default: undefined,
});
